
import CallAdd from "../../../assets/duotone/CallAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CallAddIcon({ className, dataTestid = "CallAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CallAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
